import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <section className="footer bg-[#1A1A1A] w-full h-auto lg:h-[492px] flex flex-col justify-center items-center overflow-x-hidden pt-12 pb-6 lg:py-0">
      <div className="lg:w-[1512px] lg:h-[492px] md:w-[834px] md:h-[367px] w-full h-auto lg:px-[64px] md:px-[64px] md:mt-[96px] lg:mt-[120px] ">
        <div className="grid grid-cols-2 gap-x-4 md:gap-x-0 md:flex md:flex-row md:flex-wrap justify-between gap-y-10 px-6 text-left md:text-left lg:w-[1299px] lg:h-[148px] md:w-[706px] md:h-[135px] w-full h-auto ">

          {/* Column 1 */}
          <div className="col-span-2 md:col-span-1 w-full md:w-[183px] lg:w-[470px] order-1 md:order-1 ">
            <div className="mb-8">
              <img src="/Asset-3.png" alt="Znorm Homes Logo" className="w-[200px] md:w-[200px] lg:w-[240px] h-auto object-contain" />
            </div>


            {/* <p className="font-[400] text-[16px] leading-[155%] tracking-[-0.03em] text-[#D0D0D0] font-open-sans">
  Discover the epitome of sophistication at Premium where every stay is a blend of opulence and personalized service. Immerse yourself in a world of Premium that transcends expectations.
</p> */}
            <p className="text-[#D0D0D0] text-[12px] md:text-[14px] lg:text-[16px] font-open-sans  font-[400]">
              Discover the epitome of sophistication at Premium where every stay is a blend of opulence and personalized service. Immerse yourself in a world of Premium that transcends expectations.
            </p>
          </div>

          {/* Column 2 */}

          <div className="col-span-1 w-full md:w-[111px] lg:w-[158px] md:px-6 order-3 md:order-2">
            <h4 className=" text-white mb-4 text-[18px] md:text-[20px] lg:text-[24px] font-outfit font-medium">Company</h4>
            <ul className="space-y-2">
              <li><a href="/aboutus" className="text-[#D0D0D0] text-[12px] md:text-[14px] lg:text-[16px] font-outfit font-[350] hover:text-gray-400 ">About</a></li>
              <li><Link to="/#gallery" className="text-[#D0D0D0] text-[12px] md:text-[14px] lg:text-[16px] font-outfit font-[350] hover:text-gray-400 ">Gallery</Link></li>
              <li><a href="/blog" className="text-[#D0D0D0] text-[12px] md:text-[14px] lg:text-[16px] font-outfit font-[350] hover:text-gray-400 ">Blog</a></li>
            </ul>
          </div>

          {/* Column 3 */}
          <div className="col-span-1 w-full md:w-[138px] lg:w-[154px] md:px-2 order-2 md:order-3">
            <h4 className=" text-white mb-4 text-[18px] md:text-[20px] lg:text-[24px] font-outfit font-medium">Information</h4>
            <ul className="space-y-2">
              <li><a href="/faq" className="text-[#D0D0D0] text-[12px] md:text-[14px] lg:text-[16px] font-outfit font-[350] hover:text-gray-400 ">FAQ</a></li>
              <li><a href="/data-rights" className="text-[#D0D0D0] text-[12px] md:text-[14px] lg:text-[16px] font-outfit font-[350] hover:text-gray-400 ">Data Rights</a></li>
              <li><a href="/terms-of-use" className="text-[#D0D0D0] text-[12px] md:text-[14px] lg:text-[16px] font-outfit font-[350] hover:text-gray-400 whitespace-nowrap">Terms & Condition</a></li>
            </ul>
          </div>

          {/* Column 4 */}
          <div className="col-span-2 md:col-span-1 w-full md:w-[160px] lg:w-[190px] md:px-2 lg:px-0 order-4 md:order-4">
            <h4 className="text-white   mb-4 text-[18px] md:text-[20px] lg:text-[24px] font-outfit font-medium">Contact</h4>
            <ul className="space-y-2">
              <li>
                <a
                  href="tel:+918431276142"
                  className="text-white text-[12px] md:text-[14px] lg:text-[16px] font-outfit font-[350] hover:text-gray-400"
                >
                  Phone: <span className="text-[#D0D0D0]">+91 84312 76142</span>
                </a>
              </li>

              <li>
                <a
                  href="mailto:homes@znorm.org"
                  className="text-white text-[12px] md:text-[14px] lg:text-[16px] font-outfit font-[350] hover:text-gray-400"
                >
                  Email: <span className="text-[#D0D0D0]">homes@znorm.org</span>
                </a>
              </li>

              <li className="text-white text-[12px] md:text-[14px] lg:text-[16px] font-outfit font-[350] hover:text-gray-400 ">Address: <span className="text-[#D0D0D0]">
                Znorm Hospitality,
                <br />
                Znorm Pvt Ltd,
                <br />
                Bhartiya City, 560064
              </span> </li>
            </ul>
          </div>

        </div>
      </div>
      <div className="w-full border-t border-gray-500 my-6 lg:w-[1512px] "></div>
      <div className="w-full pl-4 pr-8 md:px-[64px] lg:px-[107px] lg:max-w-[1512px] text-center text-white text-xs mb-6">
        © {new Date().getFullYear()} Znorm Homes. All Rights Reserved.
      </div>
    </section>
  );
};

export default Footer;